import { useRef, useState, useEffect } from 'react';
import { motion, useInView } from 'framer-motion';
import { api } from '../api';

const ACCENT = '#5E0ED7';
const ease = [0.22, 1, 0.36, 1];

const STATIC_CLIENTS = [
  'NovaPay', 'DataStack Pro', 'HealthBridge', 'Meridian Logistics',
  'Luma Commerce', 'Buildio', 'VaultAI', 'CloudNova',
  'Nexora', 'PulseHQ', 'TerraScale', 'ArcFlow',
];

export default function TrustedBy() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });
  const [companies, setCompanies] = useState(STATIC_CLIENTS);

  useEffect(() => {
    api.getClients()
      .then(d => { if (d?.length) setCompanies(d.map(c => c.name)); })
      .catch(() => {});
  }, []);

  return (
    <section className="py-10 overflow-hidden" style={{ background: '#F9FAFB', borderTop: '1px solid rgba(0,0,0,0.06)', borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 md:px-12 lg:px-20 mb-7" ref={ref}>
        <motion.p
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, ease }}
          className="text-[11px] font-semibold tracking-[0.16em] uppercase text-center"
          style={{ color: '#9CA3AF' }}
        >
          Trusted by teams at
        </motion.p>
      </div>

      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-24 z-10 pointer-events-none" style={{ background: 'linear-gradient(to right, #F9FAFB, transparent)' }} />
        <div className="absolute right-0 top-0 bottom-0 w-24 z-10 pointer-events-none" style={{ background: 'linear-gradient(to left, #F9FAFB, transparent)' }} />

        <div className="flex overflow-hidden">
          {[0, 1].map((copy) => (
            <div
              key={copy}
              className="flex shrink-0 items-center gap-10 pr-10"
              style={{ animation: 'marquee 36s linear infinite', willChange: 'transform' }}
            >
              {companies.map((name) => (
                <div key={name} className="flex items-center gap-2.5 whitespace-nowrap">
                  <div className="w-1 h-1 rounded-full shrink-0" style={{ background: 'linear-gradient(135deg, #5E0ED7, #06B6D4)' }} />
                  <span
                    className="text-[12px] font-semibold tracking-[0.1em] uppercase"
                    style={{ color: '#6B7280' }}
                  >
                    {name}
                  </span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
